<template>
  <div class="component-homeTabs">
    <div class="tab-item" :style="{ width: `${100 / items.length}%` }" v-for="item in items" :key="item.id" @click="handleChangeTab(item)">
      <img class="tab-icon" :src="curTabId === item.id ? item.selectIcon : item.defaultIcon" />
      <div class="tab-title" :class="{ active: curTabId === item.id }">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
import { TabBar, Icon } from 'mand-mobile'
export default {
  name: 'homeTabs',
  components: {
    [TabBar.name]: TabBar,
    [Icon.name]: Icon,
  },
  created() {
    this.initTabId(this.$route.name)
  },
  watch: {
    $route(to, from) {
      this.initTabId(to.name)
    },
  },
  data() {
    return {
      curTabId: 0,
      items: [
        {
          id: 1,
          name: '首页',
          routeName: 'vphHome',
          defaultIcon: require('../assets/images/tabbar/tab_home_unselect.png'),
          selectIcon: require('../assets/images/tabbar/tab_home_select.png'),
        },
        {
          id: 2,
          name: '搜索',
          routeName: 'vphSearch',
          defaultIcon: require('../assets/images/tabbar/tab_circle_unselect.png'),
          selectIcon: require('../assets/images/tabbar/tab_circle_select.png'),
        },
        {
          id: 3,
          name: '我的',
          routeName: 'vphMine',
          defaultIcon: require('../assets/images/tabbar/tab_mine_unselect.png'),
          selectIcon: require('../assets/images/tabbar/tab_mine_select.png'),
        },
      ],
    }
  },
  methods: {
    /**
     * 初始化tabId
     */
    initTabId(routeName) {
      this.items.forEach(item => {
        if (item.routeName === routeName) {
          this.curTabId = item.id
        }
      })
    },
    /**
     * 切换tab
     */
    handleChangeTab(item) {
      if (this.curTabId !== item.id) {
        this.curTabId = item.id
        this.$router.push({ name: item.routeName })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.component-homeTabs {
  position: fixed;
  display: flex;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1rem;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  z-index: 10;
  .tab-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 1rem;
    .tab-icon {
      height: 0.4rem;
    }
    .tab-title {
      margin-top: 0.08rem;
      font-size: 0.2rem;
      color: #666;
      &.active {
        color: #f42f19;
        font-weight: 600;
      }
    }
  }
}
</style>
